// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal__header":"BaseModalHeader_pintxo-modal__header__2Mr_E","pintxo-modal__header__slot":"BaseModalHeader_pintxo-modal__header__slot__4ZlJt"};